module.exports = __webpack_public_path__ + "img/guihua-1.b620b6a6.jpg";